import axios from 'axios'
import app from '@/main'
import { sessionResource } from '@/api'

export default () => {
  const baseDomain = 'https://hivetv-api-dev.azurewebsites.net/api/v4'
  const baseURL = `${baseDomain}/Viewer`

  const user = JSON.parse(localStorage.getItem('user'))
  let headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  if (user) {
    headers['Authorization'] = `Bearer ${user.token}`
  }

  const api = axios.create({
    baseURL,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })

  api.interceptors.request.use(config => {
    app.$Progress.start()
    return config
  })

  api.interceptors.response.use(res => {
    app.$Progress.finish()
    return res
  }, errorResponseHandler)

  return api
}

function errorResponseHandler (err) {
  // Passing the config property { errorHandler: false } in a request turns off error handling
  if (err.config.hasOwnProperty('errorHandler') && err.config.errorHandler === false) {
    return Promise.reject(err)
  }

  if (err.hasOwnProperty('response') && err.response.hasOwnProperty('status')) {
    const status = err.response.status

    if (status === 400) {
      console.log(err)
    } else if (status === 401) {
      app.$notify({
        type: 'error',
        title: 'Session Timed Out',
        text: 'Your session has expired, redirecting to login...'
      })

      sessionResource.logout()
      window.location.reload(true)
    } else if (status === 404) {
      app.$notify({
        type: 'error',
        title: 'Resource Not Found',
        text: err.response.data.message
      })
    } else if (status === 422) {
      app.$notify({
        type: 'error',
        title: 'Validation Error',
        text: err.response.data.message
      })
    } else if (status >= 500) {
      app.$notify({
        type: 'error',
        title: 'Server Error',
        text: err.response.data.message
      })
    } else {
      app.$notify({
        type: 'error',
        title: 'Error',
        text: err.response.data.message
      })
    }
  }
}
